import { Prop } from "../../../models/Prop";
import { UsedProp } from "../../../models/UsedProp";
import Interaction, { InteractionType } from "../../../models/interactions/Interaction";
import { IInspectProp } from "../../../models/interactions/InspectProp";
import { IWaitForClick } from "../../../models/interactions/WaitForClick";
import {
  IClickIndicator,
} from "../../../models/interactions/ClickIndicator";
import {
  IHideClickIndicator,
} from "../../../models/interactions/HideClickIndicator";
import { IAttach } from "../../../models/interactions/Attach";
import { IDetach } from "../../../models/interactions/Detach";

export function getSelectedPropInstanceId(
  interaction: Interaction | undefined,
): string {
  if (!interaction) return "";

  switch (interaction.type) {
    case InteractionType.InspectProp:
      return (interaction as IInspectProp).propId;
    case InteractionType.WaitForClick:
      return (interaction as IWaitForClick).propGuid;
    case InteractionType.ClickIndicator:
      return (interaction as IClickIndicator).propGuid;
    case InteractionType.HideClickIndicator:
      return (interaction as IHideClickIndicator).propGuid;
    case InteractionType.Attach:
      return (interaction as IAttach).propGuid;
    case InteractionType.Detach:
      return (interaction as IDetach).propGuid;
    default:
      return "";
  }
}

export function applyPickedPropToInteraction(
  interaction: Interaction,
  prop: Prop,
  getUsedPropByInstanceId?: (instanceId: string) => UsedProp | undefined,
): Interaction {
  switch (interaction.type) {
    case InteractionType.InspectProp: {
      const inspectInteraction = interaction as IInspectProp;
      return {
        ...inspectInteraction,
        propId: prop.id,
        tag: inspectInteraction.propId !== prop.id ? "" : inspectInteraction.tag,
      } as IInspectProp;
    }
    case InteractionType.WaitForClick: {
      const waitForClickInteraction = interaction as IWaitForClick;
      return {
        ...waitForClickInteraction,
        propGuid: prop.id,
        tag:
          waitForClickInteraction.propGuid !== prop.id
            ? ""
            : waitForClickInteraction.tag,
      } as IWaitForClick;
    }
    case InteractionType.ClickIndicator: {
      const clickIndicatorInteraction = interaction as IClickIndicator;
      return {
        ...clickIndicatorInteraction,
        propGuid: prop.id,
        tag:
          prop.id !== clickIndicatorInteraction.propGuid ? "" : clickIndicatorInteraction.tag,
      } as IClickIndicator;
    }
    case InteractionType.HideClickIndicator: {
      const hideClickIndicatorInteraction = interaction as IHideClickIndicator;
      return {
        ...hideClickIndicatorInteraction,
        propGuid: prop.id,
        tag:
          prop.id !== hideClickIndicatorInteraction.propGuid ? "" : hideClickIndicatorInteraction.tag,
      } as IHideClickIndicator;
    }
    case InteractionType.Attach: {
      const attachInteraction = interaction as IAttach;
      let tag = attachInteraction.tag;

      if (prop.id !== attachInteraction.propGuid) {
        if (!getUsedPropByInstanceId) {
          return {
            ...attachInteraction,
            propGuid: prop.id,
            prefabName: prop.prefabName,
            tag: "",
          } as IAttach;
        }
        const usedProp = getUsedPropByInstanceId(prop.id);
        tag = usedProp?.metadata.attachmentTags?.[0]?.tag ?? "";
      }

      return {
        ...attachInteraction,
        propGuid: prop.id,
        prefabName: prop.prefabName,
        tag,
      } as IAttach;
    }
    case InteractionType.Detach: {
      const detachInteraction = interaction as IDetach;
      return {
        ...detachInteraction,
        propGuid: prop.id,
      } as IDetach;
    }
    default:
      return interaction;
  }
}
